export default {
  fields: {
    online_shop_domain: 'Domaine propre pour la boutique en ligne',
    online_shop_domain_hint:
      "Un domaine appartenant au restaurant, par exemple order.pizzeria-mario.com — uniquement pour les commandes ; un site web a besoin d'un autre domaine. Une fois enregistré, les enregistrements à ajouter s'affichent ici.",
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
